import { type ChangelogRelease } from '@webapp/platform/discover-more/entities/ChangelogRelease'

export interface GetChangelogHighlightsParams {
  releases: ChangelogRelease[]
  limit: number
}

/**
 * Picks the releases the in-product What's new surfaces show, in display order:
 *
 * 1. Releases without a hero image are dropped — the surfaces are image-led, so
 *    a release with no image is skipped and backfilled by the next newest one.
 * 2. The newest remaining featured release is pinned first, even when other
 *    releases are more recent.
 * 3. The rest fill the remaining slots newest-first, up to `limit`.
 *
 * Shared by the Discover more What's new tab and the homepage promo widget so
 * both surface the same set.
 */
export const getChangelogHighlights = ({
  releases,
  limit,
}: GetChangelogHighlightsParams): ChangelogRelease[] => {
  const newestFirst = releases
    .filter((release) => release.hasHeroImage)
    .sort((a, b) => b.publishedAtTimestamp - a.publishedAtTimestamp)

  const featured = newestFirst.find((release) => release.isFeatured)

  const remaining = newestFirst.filter((release) => release !== featured)

  return [...(featured ? [featured] : []), ...remaining].slice(0, limit)
}
